import config from '../../config'

export const fetchData = () => ({
    type: 'GOOGLE_SHEETS_REQUEST', 
    payload: {
        range: 'Научни Форуми!A:Z',
        spreadsheetId: config.spreadsheetId,
        key: config.GoogleAPIkey,
        label: 'Conferences'
    }
})

export default {
    fetchData
}


// WEBPACK FOOTER //
// ./src/modules/Conferences/actions.js